import { render, staticRenderFns } from "./SidePanelAds.vue?vue&type=template&id=9f8c9ae6&scoped=true"
import script from "./SidePanelAds.vue?vue&type=script&lang=js"
export * from "./SidePanelAds.vue?vue&type=script&lang=js"
import style0 from "./SidePanelAds.vue?vue&type=style&index=0&id=9f8c9ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8c9ae6",
  null
  
)

export default component.exports